import {Component, inject} from "@angular/core";
import {Observable} from "rxjs";
import {DateTime} from "luxon";

import {CalendarService, DateUtils, ErrorWrapper, ErrorWrapperFactory, Holiday} from "@kwsoft/otcx-core";

@Component({
    selector: "otcx-home-trading-days",
    templateUrl: "./home-trading-days.component.html",
    styleUrls: ["./home-trading-days.component.scss"],
    standalone: false
})
export class HomeTradingDaysComponent {
    holidaysLoader: ErrorWrapper<Holiday[]>;
    isExpanded = false;

    fromApiDate = DateUtils.fromApiDate;

    private readonly calendarService = inject(CalendarService);
    private readonly errorWrapperFactory = inject(ErrorWrapperFactory<Holiday[]>);

    get showToggleButton(): boolean {
        return !this.holidaysLoader || !this.holidaysLoader.hasError;
    }

    toggleExpand(): void {
        this.isExpanded = !this.isExpanded;
        if (!this.holidaysLoader) {
            this.holidaysLoader = this.errorWrapperFactory.wrap(this.getHolidaysForAYear());
        }
    }

    private getHolidaysForAYear(): Observable<Holiday[]> {
        return this.calendarService.getHolidays(DateUtils.toApiDate(DateTime.local()),
            DateUtils.toApiDate(DateTime.local().plus({years: 1})));
    }

}
